module.exports = __webpack_public_path__ + "static/media/trump-left-gray.918cc19f.svg";